export class SessionKeys {
    public static autho_token = 'autho_token';
    public static userDetail='user';
    public static USER = 'credentials'
    public static Menu_Details = 'menu_details'
}
